'use client';

import { ThemeProvider as NextThemesProvider } from 'next-themes';
import type { ReactNode } from 'react';

/**
 * Wraps the app tree with next-themes so the `.dark` class can toggle the
 * MD3 token table defined in `global.css` (`.dark { --background, --surface-*,
 * --foreground … }`). All component surfaces are already token-driven, so
 * flipping the class swaps the whole theme.
 *
 * `attribute="class"` matches the `.dark` selector used by global.css.
 * `defaultTheme="system"` honours the OS preference on first paint.
 * `enableSystem` keeps the "system" choice live as the OS preference changes.
 * `disableTransitionOnChange` avoids token-driven color transitions firing
 * during the theme swap (each color CSS var is animated by various components).
 */
function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}

export default ThemeProvider;
